import TokenPair from '@square/dashboard-data/models/squareup/common/token/token-pair';
import { attr, ProtoBaseModel, repeated } from '@square/dashboard-data/utils/ember-model-stubs';
import UUID from 'uuid-js';
const Invoice = ProtoBaseModel.extend({
  invoiceTokenPair: attr(TokenPair),
  version: attr(String),
  clone() {
    const invoiceClone = Invoice.deserialize(Invoice.serialize(this));
    invoiceClone.set('invoiceTokenPair', TokenPair.create({
      clientToken: UUID.create().toString()
    }));
    return invoiceClone;
  }
});
export const PricingEngineState = ProtoBaseModel.extend({
  blacklistedDiscountIds: repeated(String),
  blocklistedTaxIds: repeated(String, {
    default: []
  })
});
const FeatureDetails = ProtoBaseModel.extend({
  invoice: attr(Invoice),
  pricingEngineState: attr(PricingEngineState),
  clone() {
    return FeatureDetails.create({
      invoice: this.invoice && this.invoice.clone()
    });
  }
}).reopenClass({
  createDefault() {
    return this.create({
      invoice: Invoice.create({
        invoiceTokenPair: TokenPair.create({
          clientToken: UUID.create().toString()
        })
      })
    });
  }
});
export default FeatureDetails;